/**
 * AnalyticsTracker — fire-and-forget pageview beacon on every route change.
 * Also exports trackEvent() for funnel events (registration, school_lead).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const sessionId = () => {
  let sid = sessionStorage.getItem('hibff_sid');
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('hibff_sid', sid);
  }
  return sid;
};

export const trackEvent = (eventType, extra = {}) => {
  try {
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: window.location.pathname,
        event_type: eventType,
        lang: localStorage.getItem('hibff_lang') || 'en',
        session_id: sessionId(),
        referrer: document.referrer ? new URL(document.referrer).hostname : '',
        ...extra,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* never break the app for analytics */ }
};

export const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackEvent('pageview');
  }, [location.pathname]);
  return null;
};

export default AnalyticsTracker;
